import { InjectionToken } from '@angular/core';

export const AUTH_SERVICE = new InjectionToken('AUTH_SERVICE');
export const PUBLIC_FALLBACK_PAGE_URI = new InjectionToken('PUBLIC_FALLBACK_PAGE_URI');
export const PROTECTED_FALLBACK_PAGE_URI = new InjectionToken('PROTECTED_FALLBACK_PAGE_URI');
